import React, { createRef } from 'react';
import Swiper from 'swiper'
import SwiperCore, { Mousewheel, Navigation, Pagination } from 'swiper/core';
import '../../../../../node_modules/swiper/swiper-bundle.css';
import './style.scss';

SwiperCore.use([Mousewheel, Navigation, Pagination]);

export default class PageSlider extends React.Component {

    sliderEl = createRef();
    sliderPrevEl = createRef();
    sliderNextEl = createRef();
    sliderPagination = createRef();

    constructor() {
        super();
        this.state = { transitionClass: '' };
    }

    componentDidMount() {
        this.swiper = new Swiper(this.sliderEl.current, {
            direction: 'vertical',
            autoHeight: true,
            loop: false,
            autoplay: false,
            resistance: false,
            mousewheel: true,
            pagination: {
                el: this.sliderPagination.current,
                clickable: true
            },
            // navigation: {
            //     prevEl: this.sliderPrevEl.current,
            //     nextEl: this.sliderNextEl.current
            // }
        });

        this.swiper.on('beforeTransitionStart', (swiper, speed, internal) => {
            let cl = '';
            if (swiper.previousIndex == 2 && swiper.activeIndex == 1) {
                cl = 'black-to-white';
            } else if (swiper.previousIndex == 1 && swiper.activeIndex == 2) {
                cl = 'white-to-black';
            }
            this.setState({ transitionClass: cl });
        });
    }

    render() {
        return (
            <div className="page-slider" ref={this.sliderEl} id={this.props.id}>
                <div className="swiper-wrapper">
                    {this.props.children}
                </div>
                <div className={"swiper-pagination " + (this.state.transitionClass)} ref={this.sliderPagination}></div>
                {/* <div className="swiper-navigation">
                    <div className="swiper-button-prev" ref={this.sliderPrevEl}></div>
                    <div className="swiper-button-next" ref={this.sliderNextEl}></div>
                </div> */}
            </div>
        )
    }
}
